import React from 'react';

export interface PowerUpPlanWeekPreviewProps {
  calendarOn: boolean;
  wearableOn: boolean;
  todosOn: boolean;
}

const WEEK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

interface PreviewEvent {
  d: number;
  top: number;
  h: number;
  kind: string;
  label?: string;
  needs: 'calendar' | 'wearable' | 'todos';
}

const PREVIEW_EVENTS: PreviewEvent[] = [
  { d: 0, top: 14, h: 28, kind: 'meet', needs: 'calendar' },
  { d: 1, top: 60, h: 22, kind: 'meet', needs: 'calendar' },
  { d: 2, top: 12, h: 28, kind: 'meet', needs: 'calendar' },
  { d: 3, top: 88, h: 32, kind: 'meet', needs: 'calendar' },
  { d: 4, top: 18, h: 22, kind: 'meet', needs: 'calendar' },
  { d: 0, top: 170, h: 18, kind: 'meal', label: 'Lunch', needs: 'calendar' },
  { d: 1, top: 180, h: 18, kind: 'meal', label: 'Lunch', needs: 'calendar' },
  { d: 2, top: 170, h: 18, kind: 'meal', label: 'Lunch', needs: 'calendar' },
  { d: 3, top: 180, h: 18, kind: 'meal', label: 'Lunch', needs: 'calendar' },
  { d: 4, top: 170, h: 18, kind: 'meal', label: 'Lunch', needs: 'calendar' },
  { d: 0, top: 230, h: 22, kind: 'wo', label: 'Workout', needs: 'calendar' },
  { d: 2, top: 230, h: 22, kind: 'wo', label: 'Workout', needs: 'calendar' },
  { d: 4, top: 230, h: 22, kind: 'wo', label: 'Workout', needs: 'calendar' },
  { d: 0, top: 60, h: 50, kind: 'deep', label: 'Deep', needs: 'wearable' },
  { d: 1, top: 16, h: 40, kind: 'deep', label: 'Deep', needs: 'wearable' },
  { d: 2, top: 60, h: 50, kind: 'deep', label: 'Deep', needs: 'wearable' },
  { d: 3, top: 22, h: 50, kind: 'deep', label: 'Deep', needs: 'wearable' },
  { d: 4, top: 60, h: 40, kind: 'deep', label: 'Deep', needs: 'wearable' },
  { d: 0, top: 264, h: 22, kind: 'wind', label: 'Wind', needs: 'wearable' },
  { d: 1, top: 264, h: 22, kind: 'wind', label: 'Wind', needs: 'wearable' },
  { d: 2, top: 264, h: 22, kind: 'wind', label: 'Wind', needs: 'wearable' },
  { d: 0, top: 116, h: 22, kind: 'todo', label: 'Spec', needs: 'todos' },
  { d: 1, top: 130, h: 22, kind: 'todo', label: 'Review', needs: 'todos' },
  { d: 2, top: 116, h: 22, kind: 'todo', label: 'Draft', needs: 'todos' },
  { d: 3, top: 130, h: 22, kind: 'todo', label: 'Reply', needs: 'todos' },
  { d: 4, top: 116, h: 22, kind: 'todo', label: 'Polish', needs: 'todos' },
];

export const PowerUpPlanWeekPreview: React.FC<PowerUpPlanWeekPreviewProps> = ({
  calendarOn,
  wearableOn,
  todosOn,
}) => {
  const isOn = (needs: PreviewEvent['needs']) => {
    if (needs === 'calendar') return calendarOn;
    if (needs === 'wearable') return wearableOn;
    return todosOn;
  };

  const previewLabel =
    calendarOn && wearableOn && todosOn
      ? 'Plan tuned to your real energy'
      : 'Integrate your data to personalize your plan';

  return (
    <div className="power-up-plan-page__visual" aria-hidden="true">
      <div className="power-up-plan-page__week">
        <div />
        {WEEK_DAYS.map((d) => (
          <div key={d} className="power-up-plan-page__week-colhead">
            {d}
          </div>
        ))}
        <div className="power-up-plan-page__week-gutter">
          <span>9</span>
          <span>12</span>
          <span>3</span>
          <span>6</span>
        </div>
        {[0, 1, 2, 3, 4].map((d) => (
          <div key={d} className="power-up-plan-page__week-col">
            {wearableOn && (
              <div className="power-up-plan-page__peak-band" style={{ top: 22, height: 50 }} />
            )}
            {PREVIEW_EVENTS.filter((e) => e.d === d).map((e, i) => (
              <div
                key={i}
                className={`power-up-plan-page__ev power-up-plan-page__ev--${e.kind}`}
                style={{ top: e.top, height: e.h, opacity: isOn(e.needs) ? 1 : 0 }}
              >
                {e.label}
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="power-up-plan-page__visual-caption">
        <div className="power-up-plan-page__visual-ring" />
        <div>
          <div className="power-up-plan-page__visual-caption-eyebrow">Preview · this week</div>
          <div className="power-up-plan-page__visual-caption-text">{previewLabel}</div>
        </div>
      </div>
    </div>
  );
};
